import { useTranslation } from 'react-i18next';

interface StatusBadgeProps {
    isActive: boolean;
}

export const StatusBadge = ({ isActive }: StatusBadgeProps) => {
    const { t } = useTranslation();

    if (isActive) {
        return (
            <span className="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400">
                {t('plan.statusActive')}
            </span>
        );
    }
    return (
        <span className="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300">
            {t('plan.statusInactive')}
        </span>
    );
};

export const formatCurrency = (amount: number | string) => {
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(num);
};

export const formatNumber = (num: number) => {
    return new Intl.NumberFormat('vi-VN').format(num);
};
